// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__ZiKm8","name":"ConsentHeader_name__2F8Eb","birthday":"ConsentHeader_birthday__2-73m","skeleton":"ConsentHeader_skeleton__1Hw7q"};